























































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";

interface Post {
  uid: string
  title: string
  content: string
  createdAt: string
  tags: Array<string>
  image: string
}

@Component
export default class IotComponent extends Vue {
  @Prop()
  private msg!: string;
  private uid: string = '?'
  private title: string = '?'
  private content: string = '?'
  private createdAt: string = '?'
  private tags: Array<string> = ['?']
  private image: string = '?'
  
  //private posts: Array<string> = ['AnAKLGcDD8fpYwD1UQhl', 'FvT2sbUSkSASF978fcAw', 'a9FWwIqt4nXdrUfVfssU']
  private posts: Array<Post> = []

  private postIndex = 0
  
  //private posts:Array<Post> = [Post?]

	created () {
		this.queryProc2()
		//this.firstPost()
	}

	public previousPost() {
		this.postIndex --
		if (this.postIndex < 0) {
			this.postIndex = this.posts.length - 1
		}
		//this.queryProc(this.posts[this.postIndex])
	    var post = this.posts[this.postIndex]
		this.uid = post.uid
		this.title = post.title
		this.content = post.content
		this.createdAt = post.createdAt
		this.tags = post.tags
		this.image = post.image
	}
	public firstPost() {
		this.postIndex = 0
		//this.queryProc(this.posts[this.postIndex])
	    var post = this.posts[this.postIndex]
		this.uid = post.uid
		this.title = post.title
		this.content = post.content
		this.createdAt = post.createdAt
		this.tags = post.tags
		this.image = post.image
	}
	public nextPost() {
		//window.console.log("nextImage() 1.this.imageSrc: " + this.imageSrc);
		this.postIndex ++
		if (this.postIndex > this.posts.length - 1) {
			this.postIndex = 0
		}
		//this.queryProc(this.posts[this.postIndex])
	    var post = this.posts[this.postIndex]
		this.uid = post.uid
		this.title = post.title
		this.content = post.content
		this.createdAt = post.createdAt
		this.tags = post.tags
		this.image = post.image

	}

	/*
	public queryProc(id: string) {
		window.console.log("queryProc() 1.")
		const postsRef = this.$firestore.collection('posts')
		const post1 = postsRef.doc(id).get().then((doc: any) => {
			if (doc.exists) {
				const post:Post = doc.data()
				this.uid = post.uid
				this.title = post.title
				this.content = post.content
				this.createdAt = post.createdAt
				this.tags = post.tags
				this.image = post.image
			
				window.console.log("queryProc() 2." + post.title)
				return doc.data() as Post; // キャスト必要
			} else {
				window.console.log("queryProc() 3.No Document")
			}
		})
		window.console.log("queryProc() 4." + this.$watanabe)
	}
	*/
	
	public queryProc2() {
		window.console.log("queryProc2() 1.")
		const postsRef = this.$firestore.collection('posts')
		postsRef.get().then((snapShot: any) => {
			snapShot.forEach ((doc: any) => {
				var data = doc.data()
				var post: Post = {uid:data.uid, title:data.title, content:data.content, createdAt:data.createdAt, tags:data.tags, image:data.image}
				this.posts.push(post)
				this.firstPost()
				window.console.log("queryProc2() 1.posts: " + this.posts)
			
			})
		})
		window.console.log("queryProc2() 4." + this.$watanabe)
	}
	
	public addDocument() {
		window.console.log("addDocument() 1.")
		var post1: Post = {
			uid:"0001",
			title:"ダンスの練習",
			content:"トークAでダンスの練習を始めましょう",
			createdAt:"2020-11-6",
			tags:["Dance"],
			image:"http://www.hiroict.com/img/akiko/firestore_1.png"
		}
		const postsRef = this.$firestore.collection('posts')
		postsRef.add(post1)
		.then((docRef: any) => {
			window.console.log("addDocument() 2.Document written with ID: " + docRef.id)
		})
		.catch((error: any) => {
			window.console.log("addDocument() 3.Error adding document: " + error)
		})
	}

} // end of export
